import { B2bRecurringInvestmentsList } from '@sh4res/bo-common/components/B2bRecurringInvestments/B2bRecurringInvestmentsList';
import { B2bRecurringInvestmentsShow } from '@sh4res/bo-common/components/B2bRecurringInvestments/B2bRecurringInvestmentsShow';

import { ResourceDefinition } from '@Utils/types';

export const recurringInvestmentsResource: ResourceDefinition = {
  options: { label: 'menu.recurring_voluntary_deposits' },
  list: (props) => (
    <B2bRecurringInvestmentsList testId="BoExternalB2bRecurringInvestmentsList" {...props} />
  ),
  show: () => <B2bRecurringInvestmentsShow />,
};
